module.exports = __webpack_public_path__ + "static/cardstructure-standalone-d6807423f029773477cd1cfd70ebee2a.png";